<template>
  <div id="s-menu" class="s-base">
    <v-card class="menu-panel s-panel" max-width="1000">
      <span class="menu-title">メニュー</span>
      <v-container>
        <v-row class="menu-list-item" align="center">
          <v-col align-self="center">
            <div class="mx-auto" style="width:500px">
              <v-btn
                class="menu-btn"
                color="secondary"
                @click="clickMenu('ContractList')"
                >契約者管理</v-btn
              >
            </div>
          </v-col>
        </v-row>

        <v-row class="menu-list-item" align="center">
          <v-col>
            <div class="mx-auto" style="width:500px">
              <v-btn
                class="menu-btn"
                color="secondary"
                @click="clickMenu('ServerList')"
                >サーバ管理</v-btn
              >
            </div>
          </v-col>
        </v-row>

        <v-row class="menu-list-item" align="center">
          <v-col>
            <div class="mx-auto" style="width:500px">
              <v-btn
                class="menu-btn"
                color="secondary"
                @click="clickMenu('ErrorList')"
                >障害管理</v-btn
              >
            </div>
          </v-col>
        </v-row>

        <v-row class="menu-list-item" align="center">
          <v-col>
            <div class="mx-auto" style="width:500px">
              <v-btn
                class="menu-btn"
                color="secondary"
                @click="clickMenu('NoticeEditor')"
                >配信お知らせ管理</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Menu extends Vue {
  clickMenu(name: string) {
    this.$router.push({ name: name });
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/common.scss";
div#s-menu {
  height: 100%;
}
.menu-panel {
  span.menu-title {
    font-size: 20pt;
    font-weight: 900;
    color: #2b72de;
  }
  .menu-list-panel {
    padding: 4px 24px 4px 24px;
  }
  .menu-list-item {
    padding: 16px 0 0 0;
  }
  .menu-btn {
    width: 100%;
  }
  .menu-btn-info {
    text-align: left;
    font-size: 10.5pt;
  }
}
</style>
